// MARCA GALARYA CARE · único origen del logo en la consola. Se usan los archivos ORIGINALES
// entregados (logo horizontal para fondo claro y para fondo oscuro): aquí sólo se elige el archivo
// según el fondo y se escala sin deformar. El símbolo es un recorte del mismo archivo, para los
// espacios estrechos donde el lema no sería legible (barra lateral de 64 px).
export const LOGO_CLARO = "/brand/galarya-horizontal-claro.png";
export const LOGO_OSCURO = "/brand/galarya-horizontal-oscuro.png";
export const LOGO_SIMBOLO = "/brand/galarya-simbolo.png";

export default function LogoGalarya({ className = "h-10 w-auto", variante = "auto", testId }) {
  const base = `${className} object-contain`;
  if (variante === "simbolo") {
    return (
      <img src={LOGO_SIMBOLO} alt="Galarya Care" data-testid={testId} className={base} />
    );
  }
  if (variante === "claro") {
    return <img src={LOGO_CLARO} alt="Galarya Care" data-testid={testId} className={base} />;
  }
  // AUTO · el mismo logo en dos archivos: el claro en tema de día, el oscuro en tema de noche.
  return (
    <span data-testid={testId} className="inline-flex shrink-0 items-center">
      <img src={LOGO_CLARO} alt="Galarya Care" className={`${base} dark:hidden`} />
      <img src={LOGO_OSCURO} alt="" aria-hidden="true" className={`${base} hidden dark:block`} />
    </span>
  );
}
